<template>
    <div id="relay_setup">
        <v-card id="relays_card" class="tab_card">
            <v-card-title>
              <span class="main_card_title">{{$i18n.t('pages.devices.relays.relays_settings')}}</span>
            </v-card-title>
            <v-card-text>
                <v-data-table
                dense
                :headers="relay_datatable_headers"
                :items="relays_data"
                :footer-props="{
                itemsPerPageText: $i18n.t('table_footers.rows_per_page'),
                itemsPerPageOptions: [10, 20, 30, 50],
                }"
                >
                  <template #footer.page-text="props">
                  {{ $i18n.t('table_footers.some_rows_of_all', {some: `${props.pageStart}-${props.pageStop}`, all: `${props.itemsLength}`})}}
                  </template>
                  <template v-slot:item="{item, index}">
                      <tr :id="index">
                        <td>{{item.name}}</td>
                        <td>{{relay_gate_and_checkpoint_names(item).gate_name}}</td>
                        <td>{{relay_gate_and_checkpoint_names(item).checkpoint_name}}</td>
                        <td>{{item.function_type}}</td>
                        <td>{{item.external_id}}</td>
                        <td>{{item.viport_serial}}</td>
                        <td>
                         <div>
                           
                            <span v-if="viport_by_serial(item.viport_serial).connected"
                              style="height: 20px;
                                     width: 20px;
                                     background-color: #9c6;
                                     border-radius: 20px;
                                     display: inline-block;"
                            >
                            </span>
                            <span v-else
                              style="height: 20px;
                                     width: 20px;
                                     background-color: #fa4848;
                                     border-radius: 20px;
                                     display: inline-block;"
                            >
                            </span>
                         </div>
                        </td>
                        <td style="max-width: 80px">
                          <div style="display: flex; justify-content: flex-end">
                            <v-btn icon @click="open_relay_editor(item)"><v-icon>$icon_edit</v-icon></v-btn>
                            <v-btn icon  @click="delete_relay(item)"><v-icon>$icon_trash</v-icon></v-btn>
                          </div>
                        </td>
                      </tr>
                  </template>
                </v-data-table>
            </v-card-text>
        </v-card>
      <v-dialog eager
        v-model="relay_edit_dialog"
        max-width="420px"
      >
        <v-form v-model="validation.form_valid" ref="relay_form_valid">
          <v-card style="border-radius: 8px; display: flex; flex-wrap: wrap; justify-content: center" elevation="0">
              <v-card-title>
                  <span>{{$i18n.t('pages.devices.relays.dialog.edit_relay')}}</span>
              </v-card-title>
            <v-card-text style="padding: 0 30px 30px">
              <v-subheader class="subheader">{{ $i18n.t('pages.devices.relays.dialog.relay_id') }}</v-subheader>
              <v-text-field
                class="rounded_8px height-textfield"
                :placeholder="$i18n.t('pages.devices.relays.dialog.relay_id')"
                disabled readonly
                v-model="edited_relay.external_id"
                outlined
              />
              <v-subheader class="subheader margin-t">{{ $i18n.t('pages.devices.relays.dialog.relay_name') }}</v-subheader>
              <v-text-field
                outlined
                class="rounded_8px height-textfield"
                :placeholder="$i18n.t('pages.devices.relays.dialog.relay_name')"
                v-model="edited_relay.name"
                :rules="validation.rules.relay_name"
              />
              <v-subheader class="subheader margin-t">{{ $i18n.t('pages.devices.relays.dialog.relay_function') }}</v-subheader>
              <v-select
                class="rounded_8px height-textfield"
                ref="relay-action"
                v-model="edited_relay.function_type"
                :items="['open', 'close', 'open-close']"

                :placeholder="$i18n.t('pages.devices.relays.dialog.relay_function')"
                outlined
              />
              <v-subheader class="subheader margin-t">{{ $i18n.t('pages.devices.relays.dialog.checkpoint') }}</v-subheader>
              <v-select
                class="rounded_8px height-textfield"
                :placeholder="$i18n.t('pages.devices.relays.dialog.checkpoint')"
                :items="checkpoints"
                item-text="name"
                item-value="_id"
                v-model="selected_checkpoint_id"
                outlined
              >
                <!-- :rules="validation.rules.select_item" -->
                <template v-slot:selection="data">
                    {{data.item.name}}
                </template>
              </v-select>
              <v-subheader class="subheader margin-t">{{ $i18n.t('pages.devices.relays.dialog.gate') }}</v-subheader>
              <v-select
                class="rounded_8px height-textfield"
                :placeholder="$i18n.t('pages.devices.relays.dialog.gate')"
                v-model="edited_relay.gate_id"
                :items="gates_in_selected_checkpoint"
                item-text="name"
                item-value="_id"
                outlined
              >
                <template v-slot:selection="data">
                    {{data.item.name}}
                </template>
              </v-select>
              <div class="spaced-between">
                <v-btn
                    class="white--text width-170"
                    height="42"
                    color="#DBEAF1"
                    elevation="0"
                    @click="relay_edit_dialog = false"
                >
                  <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.close') }}</span>
                </v-btn>
                <v-btn
                    class="white--text width-170"
                    height="42"
                    color="#207ea9"
                    elevation="0"
                    @click="save_relay"
                >
                  <span class="button-font">{{ $i18n.t('general.save') }}</span>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
</template>

<script>
import {mapActions} from "vuex";
import {i18n} from "@/i18n";
import {common_funcs} from "@/mixins/common";

export default {
    name: "RelaySetup",
    props: ['on', 'attrs', 'checkpoints', 'gates', 'relays_data', 'viports_data'],
    mixins: [common_funcs],
    data: function () {
        // this.fetch_data()
        return {
          relay_edit_dialog: false,
          edited_relay_index: -1,
          validation: {
            form_valid: true,
            rules: {
              relay_name: [
                v => !!v || i18n.t('validation.this_field_is_required'),
              ],
              select_item: [
                v => !!v || i18n.t('validation.this_field_is_required'),
              ]
            }
          },
          relay_datatable_headers: [
            {text: i18n.t('pages.devices.relays.table.headers.relay_name'), align: 'start', value: 'name'},
            {text: i18n.t('pages.devices.relays.table.headers.gate'), value: 'gate'},
            {text: i18n.t('pages.devices.relays.table.headers.checkpoint'), value: 'checkpoint'},
            {text: i18n.t('pages.devices.relays.table.headers.relay_function'), value: 'relay_function', sortable: false},
            {text: i18n.t('pages.devices.relays.table.headers.relay_id'), value: 'external_id', sortable: false},
            {text: i18n.t('pages.devices.relays.table.headers.viport_serial_number'), value: 'viport_serial'},
            {text: i18n.t('pages.devices.relays.table.headers.connected'), value: 'connected', sortable: false},
            {text: i18n.t('pages.devices.relays.table.headers.actions'), align: 'end', value: 'actions', sortable: false}
          ],
          default_relay: {_id: '', name: '', function_type: '', external_id: '', viport_serial: '', gate_id: ''},
          edited_relay: {_id: '', name: '', function_type: '', external_id: '', viport_serial: '', gate_id: ''},

          selected_checkpoint_id: ''
        }
    },
    methods: {
      open_relay_editor: function (relay) {
        this.edited_relay_index = this.relays_data.indexOf(relay)
        Object.assign(this.edited_relay, relay)
        if (relay.gate_id) {
          this.selected_checkpoint_id = this.gates.find(gate => gate._id['$oid'] === relay.gate_id['$oid']).checkpoint_id
        }
        this.relay_edit_dialog = true
      },
      close_relay_editor: function () {
        this.validation.form_valid = true
        this.edited_relay_index = -1
        this.selected_checkpoint_id = ''
        this.$nextTick(() => {
          this.edited_relay = Object.assign({}, this.default_relay)
        })
        // this.relay_edit_dialog = false
      },
      save_relay: function () {
        if (!this.$refs.relay_form_valid.validate()) return
        let _edited_relay = this.edited_relay
        let edited_index = this.edited_relay_index
        let t = this
        if (this.edited_relay_index > -1) {
          this.$http({url: this.$http_hostname + '/viport_relays_settings/edit', data: {'relay': _edited_relay}, method: 'POST'})
          .then(() => {
            Object.assign(t.relays_data[edited_index], _edited_relay)
            t.setSnackbar({
              text: i18n.t('notifications.relays.relay_edited', {relay_name: _edited_relay.name})
            })
            t.$emit('changes_applied')
          })
          .catch(error => {
            this.show_error_message(error)
          })
        } else {
          return;
        }
        t.relay_edit_dialog = false
      },
      delete_relay: function (relay) {
        let relay_index = this.relays_data.indexOf(relay)
        let data = {'_id': relay['_id']}
        confirm(i18n.t('submissions.delete_relay', {relay_name: relay.name})) &&
        this.$http({url: this.$http_hostname + '/viport_relays_settings/delete_by_mongo_id', data: data, method: 'DELETE'})
        .then(() => {
          this.relays_data.splice(relay_index, 1)
          this.setSnackbar({
            text: i18n.t('notifications.relays.relay_deleted', {relay_name: relay.name})
          })
          this.$emit('changes_applied')
        })
        .catch(error => {
          this.show_error_message(error)
        })
      },
      // eslint-disable-next-line no-unused-vars
      relay_gate_and_checkpoint_names: function (relay) {
        let text_none = i18n.t('general.none')
        if (!relay.gate_id) return {gate_name: text_none, checkpoint_name: text_none}
        let gate = this.gates.find(gate => gate._id['$oid'] === relay.gate_id['$oid'])
        if (!gate) return {gate_name: text_none, checkpoint_name: text_none}
        if (gate.checkpoint_id) {
          let checkpoint = this.checkpoints.find(chp => chp._id['$oid'] === gate.checkpoint_id['$oid'])
          return {gate_name: gate.name, checkpoint_name: checkpoint.name}
        } else {
          return {gate_name: gate.name, checkpoint_name: text_none}
        }
      },
      viport_by_serial: function (viport_serial) {
        for (let viport of this.viports_data) {
          if (viport.serial === viport_serial) return viport
        }
        return i18n.t('general.none')
      },
      ...mapActions(['setSnackbar'])
    },

    computed: {
      gates_in_selected_checkpoint: function () {
        let gates_in_checkpoint = []
        if (this.selected_checkpoint_id) {
          this.gates.forEach(gate => {
            if (gate.checkpoint_id && gate.checkpoint_id['$oid'] === this.selected_checkpoint_id['$oid']) {
              gates_in_checkpoint.push(gate)
            }
          })
        } else {
          gates_in_checkpoint = this.gates
        }
        return gates_in_checkpoint
      },

    },
    watch: {
      relay_edit_dialog (val) {
        this.$refs.relay_form_valid.resetValidation()
        !val && this.close_relay_editor()
      }
    },
}
</script>

<style lang="scss">
.height-textfield {
  height: 56px;
}
.margin-t {
  margin-top: 15px;
}
.spaced-between {
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  /* margin: 0 15px; */
}
</style>